<template>
<v-container fill-height fluid>
	<v-data-table class="elevation-2 mx-auto d-print-only" ref="PrintArea"
		:headers="headers"
		:items="exams"
		:loading="loading"
    :search="searchTerm"
    :footer-props="footerProps"
    :items-per-page="itemsPerPage">

    <template v-slot:top>
      <v-container class="d-print-none">
        <div class="d-flex justify-space-around" >
          <h2>Examinations</h2>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" color="primary" small dark
            @click="refresh()">
            <v-icon left small>mdi-refresh</v-icon>
            Refresh
          </v-btn>
          <!-- <v-btn class="mr-2" color="primary" small dark
            @click="downloadCsv()">
            <v-icon left small>mdi-download</v-icon>
            CSV
          </v-btn> -->
          <v-btn color="primary" small dark
            @click="print()">
            <v-icon left small>mdi-printer</v-icon>
            Print
          </v-btn>
        </div>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              label="Search"
              prepend-icon="mdi-magnify"
              v-model="searchTerm"
              autocomplete="off"/>
          </v-col>
          
          <v-col cols="12" md="3">
            <v-menu
              ref="DateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Select Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hint="Select 2 dates">
                </v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                scrollable
                range
                @change="refresh()">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.DateMenu.save(date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              v-model="selectedCourse"
              @change="refresh"
              :items="courses"
              item-text="title"
              item-value="id"
              label="Course">
            </v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="selectedRegistrationStatus"
              @change="refresh"
              :items="registrationStatuses"
              item-text="label"
              item-value="value"
              label="Status">
            </v-select>
          </v-col>

        </v-row>
      </v-container>
    </template>

    <template v-slot:item._course="{ item }">
      {{ item['course.shortTitle'] || item['course.title'] }}
    </template>

		<template v-slot:item._status="{ item }">
      {{ printRegistrationStatus(item) }}
		</template>

    <template v-slot:item._actions="{ item }">
      <v-icon
        small
        class="mr-1"
        @click="copyLink(item)">
        mdi-link
      </v-icon>
      <!-- <v-icon
        small
        class="mr-1"
        @click="updateRegistration(item)">
        mdi-pencil
      </v-icon> -->
      <v-icon
        small
        @click="deleteExam(item)">
        mdi-delete
      </v-icon>
    </template>


		<!-- 
			<template v-slot:no-data>
				No Data Found
			</template> 
		-->
	</v-data-table>
</v-container>
</template>

<script>
import Api from '../../services/api'
import Notify from '../../services/notify'
import Report from '../../services/report'
import { COURSE, REGISTRATION_STATUS } from '../../services/constants'
import CourseMixin from '../../mixins/course.mixin'
import DataTableMixin from '../../mixins/data-table.mixin'
import Moment from 'moment'

export default {
	name: 'Exams',
  mixins: [ CourseMixin, DataTableMixin ],
	data() {
		return {
			exams: [],
      loading: false,
      selectedCourse: 0,
      selectedCourseType: COURSE.DIPLOMA, // DB:Diploma
			headers: [],
      dateMenu: false,
			date: [],
      searchTerm: null,
      selectedRegistrationStatus: REGISTRATION_STATUS.APPROVED,
      registrationStatuses: [
        { value: REGISTRATION_STATUS.UNPROCESSED, label: 'All' },
        { value: REGISTRATION_STATUS.APPROVED, label: 'Approved' },
        { value: REGISTRATION_STATUS.ENROLLED, label: 'Enrolled' },
        { value: REGISTRATION_STATUS.REJECTED, label: 'Rejected' },
      ],
		}
	},
	created() {
		this.date = [
			Moment().subtract(1, 'year').format('YYYY-MM-DD'),
			Moment().startOf('endOf').format('YYYY-MM-DD'),
		];

		this.getCourses();

		this.refresh();
  },
	methods: {
    setHeaders() {
      this.headers = [
				{ text: 'Exam ID', value: 'id' },
				{ text: 'Lastname', value: 'registration.lastname', align: 'start' },
				{ text: 'Firstname', value: 'registration.firstname' },
				{ text: 'Middlename', value: 'registration.middlename' },
				{ text: 'Mobile', value: 'registration.mobile' },
				{ text: 'Course', value: '_course' },
				{ text: 'Requested', value: 'requestDateTime' },
				{ text: 'Completed', value: 'completeDateTime' },
				{ text: 'Score', value: 'score', },
				{ text: 'Status', value: '_status', },
				{ text: 'Actions', value: '_actions', },
			];
    },
		refresh() {
      this.setHeaders();
      if(this.selectedCourse) {
        this.headers = this.removeHeader(this.headers, '_course');
      }

			if(this.date.length < 2) {
				this.exams = [];
				return;
			}

			this.loading = true;
			Api.exam.getAll(
        this.date[0], 
        this.date[1],
        this.selectedCourse,
        this.selectedRegistrationStatus,
        )
        .then((response) => {
          this.exams = response.data;
        })
        .finally(() => {
          this.loading = false;
          this.itemsPerPage = (this.selectedCourse)? -1 : 15;
        });
    },
    
    deleteExam(exam) {
      console.log(exam);
      Notify.confirm('Delete Examination?', "Action can't be undone.")
        .then(() => {
          Api.exam.delete(exam.id)
            .then(() => {
              Notify.success.itemDeleted();
              this.refresh();
            });
        }).catch(() => {});

    },

    copyLink(exam) {
      console.log(exam);
      
    },

    print() {
      let reportTitle = 'Examinations';

      let html = this.$refs.PrintArea.$el.outerHTML;
      let selectedCourse = this.courses.find(course => {
        return course.id == this.selectedCourse;
      });

      // this.headers = this.removeHeader(this.headers, '_actions');
      Report.print(reportTitle, selectedCourse.title, html, null, 'registration.css');
      // this.headers = this.addHeader(this.headers, 'Actions', '_actions');
      // this.$forceUpdate();

    },

    printRegistrationStatus(exam) {
      if(!exam['registration.enrollDateTime'] && !exam['registration.rejectDateTime']) {
        return 'Approved';
      }
      else if(exam['registration.enrollDateTime']) {
        return 'Enrolled';
      } 
      else if(exam['registration.rejectDateTime']) {
        return 'Rejected';
      } else {
        return 'Unprocessed';
      }
    }

  }
}
</script>